function CollapseView({ pofb, onAdjust, onView }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>Item Name:</strong> {pofb?.component?.itemName}
        </p>
        <p className="mb-1">
          <strong>Quantity:</strong> {pofb?.quantity}
        </p>

        <p className="mb-1">
          <strong>Unit of Measurement:</strong> {pofb?.component?.uom?.name}
        </p>
        <p className="mb-1">
          <strong>Date Created:</strong>{" "}
          {new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          }).format(new Date(pofb?.created))}
        </p>
      </div>

      <div className="d-flex gap-2">
        <button className="btn btn-success text-white" onClick={onAdjust}>
          <i className="bi bi-pencil me-2"></i> Adjust
        </button>
        <button
          className="btn text-dark"
          onClick={onView}
          style={{ backgroundColor: "#d1d1d1" }}
        >
          <i className="bi bi-eye me-2"></i> View
        </button>
      </div>
    </div>
  );
}

export default CollapseView;
